import React from 'react'

const MainContent = () => {
  return (
    <div className="main_content">
      <h1 className="main_logo">
        <svg viewBox="0 0 1900 250">
          <text x="50%" y="50%" text-anchor="middle" dy="50px">developer</text>
        </svg>
      </h1>

      <p className="en">Portfolio of Euzin</p>
    </div>
  )
}

export default MainContent